var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) { s = '0' + s; }
    return s;
};

export default {
    isMobile: function(mobile){
        var reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!reg.test(mobile)) {
          return false;
        } else {
          return true;
        }
    },
    getQueryStringByName: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null)
            context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {
        format: function (date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y': return padding(date.getFullYear(), $0.length);
                    case 'M': return padding(date.getMonth() + 1, $0.length);
                    case 'd': return padding(date.getDate(), $0.length);
                    case 'w': return date.getDay() + 1;
                    case 'h': return padding(date.getHours(), $0.length);
                    case 'm': return padding(date.getMinutes(), $0.length);
                    case 's': return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function (dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y': _date.setFullYear(_int); break;
                        case 'M': _date.setMonth(_int - 1); break;
                        case 'd': _date.setDate(_int); break;
                        case 'h': _date.setHours(_int); break;
                        case 'm': _date.setMinutes(_int); break;
                        case 's': _date.setSeconds(_int); break;
                    }
                }
                return _date;
            }
            return null;
        }
    },
    formatFileSize: function (value) {
        if(null==value||value==''){
            return "0 Bytes";
        }
        var unitArr = new Array("Bytes","KB","MB","GB","TB","PB","EB","ZB","YB");
        var index=0;
        var srcsize = parseFloat(value);
        index=Math.floor(Math.log(srcsize)/Math.log(1024));
        var size =srcsize/Math.pow(1024,index);
        size=size.toFixed(2);//保留的小数位数
        return size+unitArr[index];
    },
    maskString: function (start, end, value, fill = '*') {
        if (value && typeof value === 'string' && value.length > start + end) {
            const ret = value.split('');
            const length = value.length - ( start + end );
            const mask = new Array(length).join(fill);
            ret.splice(start, length, mask);
            return ret.join('');
        }
        return value;
    },
    mixTextOverflow: function(text, length) {
        if (text.replace(/[\u4e00-\u9fa5]/g, 'aa').length <= length) {
            return text;
        } else {
            var _length = 0;
            var outputText = '';
            for (var i = 0; i < text.length; i++) {
                if (/[\u4e00-\u9fa5]/.test(text[i])) {
                    _length += 2;
                } else {
                    _length += 1;
                }
                if (_length > length) {
                    break;
                } else {
                    outputText += text[i];
                }
            }
            return outputText + '...';
        }
    },
    getLeftTime: function(lasttime) {
        if (lasttime > 0) {
            const lastdate = parseInt(lasttime/3600/24);
            const lasthours = parseInt(lasttime/3600%24);
            const lastminutes = parseInt(lasttime/60%60);
            return '剩余' + lastdate  + '天'+ lasthours + '时' + lastminutes + '分';
        }
    },
    getPreMonth: function(date) {
        var arr = date.split('-');
        var year = arr[0]; //获取当前日期的年份
        var month = arr[1]; //获取当前日期的月份
        var day = arr[2]; //获取当前日期的日
        var days = new Date(year, month, 0);
        days = days.getDate(); //获取当前日期中月的天数
        var year2 = year;
        var month2 = parseInt(month) - 1;
        if (month2 == 0) {
            year2 = parseInt(year2) - 1;
            month2 = 12;
        }
        var day2 = day;
        var days2 = new Date(year2, month2, 0);
        days2 = days2.getDate();
        if (day2 > days2) {
            day2 = days2;
        }
        if (month2 < 10) {
            month2 = '0' + month2;
        }
        var t2 = year2 + '-' + month2 + '-' + day2;
        return t2;
    }
};



// WEBPACK FOOTER //
// ./src/common/js/util.js